module.exports = __webpack_public_path__ + "b750c5ee368d06f470efb6c6c20bb28e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-winter-pink.png
// module id = 2763
// module chunks = 0